import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ModifFormVybaveni from '../comp/ModifFormVybaveni';

function EditVybaveni () {
    let { vybaveniId } = useParams();
    console.log("vybaveniId "+vybaveniId)

    const vybaveni = useSelector((state: any) => state.allPrvky.vybaveni);
    let vybaveni_vybaveniId = vybaveni.find((vyb: any) => (vyb.id===vybaveniId))
    console.log("displaying vybaveni")
    console.log(vybaveni_vybaveniId) 
    return (
        <Container>
            <ModifFormVybaveni edit={true} vybaveni={vybaveni_vybaveniId} />
        </Container>)
}
export default EditVybaveni